export const INSIGHTS_PAGE = 'reports:insights-page';
export const TRENDS_PAGE = 'reports:trends-page';
export const POSITIONING_PAGE = 'reports:positioning-page';
export const BREAKDOWN_PAGE = 'reports:breakdown-page';
